module.exports = __webpack_public_path__ + "static/img/LogQuery.e8b16855.png";